var map = {
	"./Scientists-12.jpg": 43,
	"./UAI-shield.png": 93,
	"./UAI.png": 94,
	"./address_image.svg": 95,
	"./animated_logo.svg": 96,
	"./ankama.png": 97,
	"./blogs_image.svg": 98,
	"./cloud_infrastructure.svg": 99,
	"./codeInLogo.png": 100,
	"./contactMail.png": 101,
	"./coursera_logo.png": 102,
	"./data_science.svg": 103,
	"./deeplearning_ai_logo.png": 104,
	"./delhivery_logo.png": 105,
	"./developerActivity.svg": 106,
	"./di-raggio.jpg": 107,
	"./dsc_logo.png": 108,
	"./education.svg": 109,
	"./empa-logo.png": 110,
	"./empa-seeklogo.png": 111,
	"./empa_logo.jpeg": 112,
	"./experience.svg": 113,
	"./feelingProud.svg": 114,
	"./freecopy_logo.png": 115,
	"./fullstack.svg": 116,
	"./gcp_logo.png": 117,
	"./github_logo.png": 118,
	"./googleAssistant.jpg": 119,
	"./googleAssistant.svg": 120,
	"./google_logo.png": 121,
	"./iaeste.png": 122,
	"./ibm_logo.png": 123,
	"./iiitk_logo.png": 124,
	"./intel_logo.jpg": 125,
	"./iu_logo.png": 126,
	"./jsFramework.svg": 127,
	"./legato_logo.png": 128,
	"./linkedin.svg": 129,
	"./logo-uai-v2.png": 130,
	"./lol-uai.jpeg": 131,
	"./manOnTable.svg": 132,
	"./microsoft_logo.png": 133,
	"./mozilla_logo.png": 134,
	"./muffito_logo.png": 135,
	"./nextuLogo.jpg": 136,
	"./nptel_logo.png": 137,
	"./personal.jpg": 138,
	"./portfolio.gif": 139,
	"./programmer.svg": 140,
	"./projects_image.svg": 141,
	"./pwa.png": 142,
	"./saayaHealthLogo.png": 143,
	"./scout.png": 144,
	"./sonda.png": 145,
	"./stanford_logo.png": 146,
	"./talksCardBack.svg": 147,
	"./talksCardBackAlt.svg": 148,
	"./team-chile.png": 149,
	"./tiktok_logo.png": 150,
	"./uai_v2.PNG": 151,
	"./ui_ux_design.svg": 152,
	"./wedding/Hochzeitseinladung-1.png": 27,
	"./wedding/Hochzeitseinladung-2.png": 28,
	"./wedding/Hochzeitseinladung-3.png": 29,
	"./wedding/Hochzeitseinladung-4.png": 30,
	"./wedding/Hochzeitseinladung-5.png": 31,
	"./wedding/Hochzeitseinladung-6.png": 32,
	"./wedding/Hochzeitseinladung-7.png": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;